
import { computed, isVue3 } from 'virtual-vue';
import { useEmits } from './use-emits';

export interface VModelProps<T> {
  modelValue: T;
  value: T;
}

export interface VModelEvents<Value> {
  input: [currentIndex: Value];
  'update:modelValue': [currentIndex: Value];
}

export function useVModel<T>(props: VModelProps<T>) {
  const emit = useEmits<VModelEvents<T>>();
  return computed({
    get() {
      if (isVue3) {
        return props.modelValue;
      }
      return props.value;
    },
    set(currentIndex) {
      emit('input', currentIndex);
      if (isVue3) {
        emit('update:modelValue', currentIndex);
      }
    },
  });
}
